import { findOuById, getAllChildMerchants, useMerchantsWithOuName, useOrganisationHierarchy } from '@app/sdk';
import React, { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { LoadingWrapper } from '../components/LoadingWrapper';
import { Table } from '@app/shared';

export function AffectedMerchants({ selectedOuId }: { selectedOuId: string }) {
  const { data: tenantHierarchy } = useOrganisationHierarchy();
  const { isLoading: loading, data: allMerchants } = useMerchantsWithOuName();

  const affectedMerchants = useMemo(() => {
    if (tenantHierarchy && allMerchants) {
      const selectedOu = findOuById(tenantHierarchy.organisationUnit, selectedOuId);
      const merchantIds = getAllChildMerchants(selectedOu);
      return allMerchants.filter((x) => merchantIds.includes(x.merchantId));
    }
    return [];
  }, [tenantHierarchy, allMerchants, selectedOuId]);

  const columnDefs: ColDef[] = [
    { field: 'merchantId', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
    { field: 'organisationUnitName', headerName: 'Parent OU' },
  ];

  return (
    <LoadingWrapper loading={loading}>
      <div style={{ height: '350px', position: 'relative' }}>
        <Table items={affectedMerchants} columnDefs={columnDefs} noFilter />
        <div className={'ui label'} style={{ position: 'absolute', top: '-30px', right: '10px' }}>
          {affectedMerchants.length} Affected Merchants
        </div>
      </div>
    </LoadingWrapper>
  );
}
